export default __webpack_public_path__ + "static/citizen-app-f8c4b84e26cde5b47a68cc4b0cb3b526.png";